import {createGrid} from "../../helpers/grids/grids";

function initSmsIndex() {
	// Init grid
	createGrid('.sms-grid', {
			columnDefs: [
				{
					field: 'source_phone.name',
					headerName: 'To',
				},
				{
					field: 'from',
					headerName: 'From',
				},
				{
					field: 'body',
					headerName: 'Message',
					maxWidth: 400,
					wrapText: true,
					autoHeight: true,
				},
				{
					field: 'created_at',
					headerName: 'At',
					sortable: 'true',
					sort: 'desc',
				},
			],
			paginationPageSize: 20,
			_rowName: 'Messages',
			rowClass: 'cursor-pointer',
		},
		window['routes/admin.sms.grid'],
	);
}

export {
	initSmsIndex
}
